import React, { useState, useContext } from "react";
import { Layout, Icon, Button } from "@app/components";
import { AuthContext } from "@app/providers";
import { getDefaultUrl } from "@app/routes/route-helpers";
import { useLocation } from "@app/utils";
import SchoolLicenseComponent from "./school-account-setUp";
import IndividualAccountSetUpComponent from "./individual-account-setUp";
import {
  SuccessContainer,
  SuccessHeading,
  SuccessText,
} from "../educator-component";
import { TextCenter } from "@app/components/commonStyles";

export default function AccountSetUp() {
  const { navigate } = useLocation();
  const { userInfo } = useContext(AuthContext);
  let accountType: any = userInfo.userJson.educatorLicenseType;
  const [showSuccess, setShowSuccess] = useState<boolean>(false);

  function redirectToProfile() {
    const defaultUrl = getDefaultUrl(userInfo && userInfo.userJson);
    navigate(defaultUrl);
  }
  if (!showSuccess) {
    return (
      <>
        <Layout className="aligned-center">
          <h3 className="primary-header text-center mb-3">
            Educator Account Setup
          </h3>
          <h4 className="secondary-label">Select Teacher Account Type</h4>
          {accountType === "schoolLicenseCode" && (
            <SchoolLicenseComponent setShowSuccess={setShowSuccess} />
          )}
          {accountType === "teacherAccount" && (
            <IndividualAccountSetUpComponent setShowSuccess={setShowSuccess} />
          )}
        </Layout>
      </>
    );
  } else {
    return (
      <Layout className="aligned-center">
        <SuccessContainer>
          <Icon name="signsuccess" />
          <SuccessHeading>Account setup completed!</SuccessHeading>
          <SuccessText>
            Your Educator/School account has been setup successfully.
          </SuccessText>
          <TextCenter className="mb-2">
            Click here to
            <button
              className="anchor-tag"
              type="button"
              onClick={() => redirectToProfile()}
            >
              Submit Content and Monetize or to create a classroom.
            </button>

          </TextCenter>
        </SuccessContainer>
      </Layout>
    );
  }
}
